/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Photo_ChooseInputs */

const en_profile_photo_choose = /** @type {(inputs: Profile_Photo_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose photo`)
};

const pt_br2_profile_photo_choose = /** @type {(inputs: Profile_Photo_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolher foto`)
};

/**
* | output |
* | --- |
* | "Choose photo" |
*
* @param {Profile_Photo_ChooseInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_photo_choose = /** @type {((inputs?: Profile_Photo_ChooseInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Photo_ChooseInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_photo_choose(inputs)
	return pt_br2_profile_photo_choose(inputs)
});